"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNTConfig = exports.NTConfigProvider = exports.NTConfigContext = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var FosAuthorizer_1 = require("../auth/FosAuthorizer");
exports.NTConfigContext = (0, react_1.createContext)({});
var NTConfigProvider = function (_a) {
    var children = _a.children, ntConfig = _a.ntConfig, oktaAuth = _a.oktaAuth;
    if (oktaAuth) {
        FosAuthorizer_1.FosAuthorizer.use(ntConfig, oktaAuth);
    }
    else {
        FosAuthorizer_1.FosAuthorizer.init(ntConfig);
    }
    return (react_1.default.createElement(exports.NTConfigContext.Provider, { value: ntConfig }, children));
};
exports.NTConfigProvider = NTConfigProvider;
var useNTConfig = function () { return (0, react_1.useContext)(exports.NTConfigContext); };
exports.useNTConfig = useNTConfig;
